import {UpdateStatusTypes, apiLocker} from '../../../../stores/Form/API_Locker';

export const changeLockerStatus = (session: string, status: UpdateStatusTypes) => {
    const data = apiLocker.getDataBySession(session);

    if (data) {
        data.toggleStatus(status);
    }
};
